"use client";

import React from "react";

import { useTranslations } from "next-intl";

import { Card } from "@/ui/Card";
import { AddToFavorite } from "@/ui/Common/AddToFavorite";
import { cn } from "@/utils/cn";
import { Share } from "@/widgets/Share";

interface Props {
  id: string;
  title?: string;
  className?: string;
}

export const PlanDetailSocial: React.FC<Props> = ({ id, title, className }) => {
  const t = useTranslations();

  return (
    <Card className={cn("p-12", className)}>
      {/* Header */}
      <div className="flex flex-col gap-6 items-center md:items-start">
        <h3 className="text-[2.5rem] text-center md:text-left font-medium text-[#323232] leading-normal">
          {t("Did you like this apartment?")}
        </h3>
        {/* Actions */}
        <div
          className={
            " flex flex-col gap-y-3 gap-x-12 md:flex-row items-center md:items-start"
          }
        >
          {/* Share Button */}
          <Share
            className="text-[#444444]"
            title={title}
            label={<span className="text-md font-bold ">{t("Share")}</span>}
          />

          {/* Add to Favorite Button */}
          <AddToFavorite
            className={"text-[#444444]"}
            id={id}
            label={
              <span className="text-md font-bold">{t("Add to favorites")}</span>
            }
          />
        </div>
        <p className="text-[15px] font-normal text-[#444444] px-2">
          {t(
            "Add to favorites so you don't lose it or send a link to someone who helps you choose housing",
          )}
        </p>
      </div>
    </Card>
  );
};
